<template>
  <div style="width:100%;height:100%">
    <h1 class="chart-top-title">价格指数监管<span class="chart-modal-flag" @click="openModal"><i class="el-icon-view"></i></span></h1>
    <div
      ref="treeAnalysis"
      style="height:370px"
    ></div>
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true" :fullscreen="true" center :modal="mask">
      <img style="width: 100%; height: 100%;" src="../../../static/imgs/price.jpg" alt="">
    </el-dialog>
  </div>
</template>
<script>
import $ from 'jquery'
import { getTreeData } from '../../api/apiList/state'
import { vueBus } from '../../assets/js/common/vueBus'
export default {
  data() {
    return {
      dialogVisible: false,
      mask: false,
      fullscreen: true,
      treeAnalysisChart: require('./TreeAnalysisChart.min.js'),
      anima: '',
      idx: 0,
      treeData: {
        vertices: [
          {
            id: '0',
            name: '药品价格指数',
            value: '117.46',
            lastValue: '92.84'
          },
          {
            id: 'V',
            name: '抗生素价格指数',
            value: '110.16',
            lastValue: '110.42'
          },
          {
            id: 'V1',
            name: '消化系统用药',
            value: '22.69',
            lastValue: '40.86'
          },
          {
            id: 'V2',
            name: '呼吸系统用药',
            value: '23.41',
            lastValue: '14.12'
          },
          {
            id: 'V3',
            name: '心血管系统用药',
            value: '150.15',
            lastValue: '229.85'
          },
          {
            id: 'V4',
            name: '神经系统用药',
            value: '151.91',
            lastValue: '98.01'
          },
          {
            id: 'V5',
            name: '抗微生物药',
            value: '82.38',
            lastValue: '121.55'
          },
          {
            id: 'V6',
            name: '泌尿系统用药',
            value: '64.29',
            lastValue: '72.77'
          },
          {
            id: 'V7',
            name: '眼科用药',
            value: '75.85',
            lastValue: '48.6'
          },
          {
            id: 'V8',
            name: '皮肤科用药',
            value: '70.64',
            lastValue: '50.08'
          }
        ],
        edges: [
          {
            source: '0',
            target: 'V'
          },
          {
            source: 'V',
            target: 'V1'
          },
          {
            source: 'V',
            target: 'V2'
          },
          {
            source: 'V',
            target: 'V3'
          },
          {
            source: 'V',
            target: 'V4'
          },
          {
            source: 'V',
            target: 'V5'
          },
          {
            source: 'V',
            target: 'V6'
          },
          {
            source: 'V',
            target: 'V7'
          },
          {
            source: 'V',
            target: 'V8'
          }
        ]
      },
      lineChartData: [100.23, 105.87, 111.2, 120.93, 96.82, 89.14, 98.78, 115.49, 93.56, 112.91, 92.84, 117.46],
      lineChartXData: [
        '2017/01',
        '2017/02',
        '2017/03',
        '2017/04',
        '2017/05',
        '2017/06',
        '2017/07',
        '2017/08',
        '2017/09',
        '2017/10',
        '2017/11',
        '2017/12'
      ],
      axisLabelColor: '#ccd6e0',
      axisLineColor: '#809ab1'
    }
  },
  methods: {
    openModal(){
      this.dialogVisible = true
    },
    handleClose(done) {
      done();
    },
    getUpsAndDowns(val, lastVal) {
      return val - lastVal
    },
    getItem(items, map) {
      let me = this
      let itemsRet = []
      for (let i = 0; i < items.length; i++) {
        let o = map[items[i]]
        if (o != null) {
          let item = {
            id: o.id,
            name: o.name,
            index: o.value,
            percentage: me.getUpsAndDowns(o.value, o.lastValue)
          }
          itemsRet.push(item)
        }
      }
      return itemsRet
    },
    dealData(fn, data) {
      let me = this
      let dataTree = {}
      let links = data.edges
      let nodes = data.vertices
      let dataSourceToTarget = {}
      let dataTargetToSource = {}
      for (let i = 0; i < links.length; i++) {
        dataTargetToSource[links[i].target] = links[i].source
        if (dataSourceToTarget[links[i].source] == null) {
          dataSourceToTarget[links[i].source] = [links[i].target]
        } else {
          dataSourceToTarget[links[i].source].push(links[i].target)
        }
      }

      let linkMaps = {}
      for (let i = 0; i < nodes.length; i++) {
        if (dataTargetToSource[nodes[i].id] == null) {
          dataTree = {
            id: nodes[i].id,
            combinedIndex: nodes[i].value,
            allPercentage: me.getUpsAndDowns(nodes[i].value, nodes[i].lastValue),
            basket: {}
            // grainOil: {},
            // date: data.date
          }
        } else {
          linkMaps[nodes[i].id] = nodes[i]
        }
      }

      for (let i = 0; i < dataSourceToTarget[dataTree.id].length; i++) {
        let item = linkMaps[dataSourceToTarget[dataTree.id][i]]
        if (item.name === '抗生素价格指数') {
          dataTree.basket = {
            id: item.id,
            name: item.name,
            index: item.value,
            percentage: me.getUpsAndDowns(item.value, item.lastValue),
            item: me.getItem(dataSourceToTarget[item.id], linkMaps)
          }
          // } else if (item.name === '抗生素价格指数') {
          //   dataTree.grainOil = {
          //     id: item.id,
          //     name: item.name,
          //     index: item.value,
          //     percentage: me.getUpsAndDowns(item.value, item.lastValue),
          //     item: me.getItem(dataSourceToTarget[item.id], linkMaps)
          //   }
        }
      }
      fn(dataTree)
    },
    init() {
      let me = this
      let treeDom = me.$refs.treeAnalysis
      let treeAnalysis = me.treeAnalysisChart.default(treeDom)
      treeAnalysis.init()
      me.dealData(function(data) {
        treeAnalysis.show(data)
      }, me.treeData)
    },
    updateData() {
      let me = this
      if (this.idx == 1) {
        this.idx = 0
      } else {
        this.idx++
      }
    },
    initLineChart() {
      this.myChart = this.$echarts.init(this.$refs.treeAnalysis)
      let option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          show: false
        },
        xAxis: [
          {
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: this.axisLineColor
              }
            },
            axisLabel: {
              color: this.axisLabelColor
            },
            axisTick: { show: false },
            data: this.lineChartXData
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '',
            nameTextStyle: {
              color: this.axisLabelColor,
              fontSize: 16
            },
            axisLine: {
              lineStyle: {
                color: this.axisLineColor
              }
            },
            axisTick: { show: false },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 14
              },
              color: this.axisLabelColor
            },
            splitLine: {
              show: false
            }
          }
        ],
        grid: {
          top: 40,
          bottom: 50,
          left: 80,
          right: 50
        },
        series: [
          {
            name: '',
            type: 'line',
            symbol: 'circle',
            symbolSize: 0,
            lineStyle: {
              normal: {
                width: 2,
                color: '#81A566'
              }
            },
            itemStyle: {
              normal: {
                color: '#fff',
                borderColor: '#81A566',
                borderWidth: 4
              }
            },
            areaStyle: {
              normal: {
                color: 'rgba(129,156,102,.3)'
              }
            },
            data: this.lineChartData
          }
        ],
        animationEasing: 'bounceOut'
      }
      this.myChart.setOption(option)
      window.onresize = this.myChart.resize
    }
  },
  watch: {
    anima: {
      handler: function(val, oldVal) {
        let me = this
        if (val == 'animateStart') {
          this.init()
          setInterval(function() {
            me.updateData()
            if (me.idx == 0) {
             me.myChart.dispose();
             me.init()
            } else {
              var element = document.querySelector('#TreeAnalysis svg')
              element.parentNode.removeChild(element)
              me.initLineChart()
            }
          }, 10000)
        }
      }
    },
    dialogVisible: {
      handler: function(val,oldVal){
        // console.log(val,oldVal)
       if (val) {
       }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      let me = this
      vueBus.$on('imgOnload', v => {
        me.anima = v
      })
    })
  }
}
</script>
<style lang="scss" scoped>
.chart-modal-flag {
  line-height: 64px;
  font-size: 40px;
  font-weight: 700;
  color: #fff;
  right: 25px;
  position: absolute;
  i {
    color: #fff;
    cursor: pointer;
    font-weight: 900;
  }
}

.chart-top-title {
  height: 76px;
  line-height: 95px;
  font-size: 40px;
  font-weight: 700;
  color: #65ecc3;
  text-align: center;
  letter-spacing: 2px;
  position: relative;
  .chart-select {
    position: absolute;
    width: 175px;
    height: 45px;
    line-height: 45px;
    border: 2px solid #046292;
    left: 28px;
    top: 26px;
    border-radius: 8px;
    font-weight: 400;
    color: #fff;
    font-size: 20px;
    text-align: left;
    padding-left: 20px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
  }
  .select-icon {
    position: absolute;
    font-size: 26px;
    right: 10px;
    top: 3px;
  }
 }
 .remarkes {
  height: 40px;
  line-height: 24px;
  font-size: 20px;
  color: #acb4bc;
  padding-left: 50px;
}
</style>




// WEBPACK FOOTER //
// src/components/tree-analysis/treeAnalysis.vue